export default __webpack_public_path__ + "static/media/star-fill.507024f4.svg";